import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import * as moment from 'moment';
import { UserRole, IdNameModel } from 'src/app/_metronic/core/classes/core.class';
import Swal, { SweetAlertResult } from 'sweetalert2';
import * as XLSX from 'xlsx';
declare var $: any;
@Injectable()
export class CoreHelperService {
    apiUrl: any;
    constructor(private httpClient: HttpClient) {
    }

    saveGridFilter(reqData) {
        return this.httpClient.post(`${this.apiUrl}/saveGridFilter`, reqData).pipe()
    }

    parseJSONStringToArray(str: string) {
        try {
            let data = JSON.parse(str);
            if (Array.isArray(data)) return data;
            return [];
        } catch (error) {
            console.log('Error parsing data. CoreHelperService');
            return [];
        }
    }

    isNullOrUndefined<T>(tObj: T): boolean {
        return tObj === null || tObj === undefined;
    }
    isNullOrUndefinedMultiple(...tObj): boolean {
        return !tObj.every((tEntry) => tEntry !== null && tEntry !== undefined);
    }
    isArrayEmpty<T>(tArr: T[]): boolean {
        return this.isNullOrUndefined(tArr) || tArr.length <= 0;
    }
    isStringEmptyOrWhitespace(stringToParse: string) {
        if (!this.isNullOrUndefined(stringToParse) && typeof (stringToParse) == 'string') {
            if (stringToParse.trim() === "")
                return true
        }
    }

    preventCutCopyPaste(componentId) {
        $(`${componentId}`).bind("cut copy paste", (e) => {
            e.preventDefault();
        });
    }
    deleteAlert(name): any {
        Swal.fire({
            title: 'Are you sure?',
            text: name + " will be deleted",
            imageUrl: '../../../assets/svg/exlaimation-mark.svg',
            imageHeight: 79,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-trash-o"></i> Delete',
            cancelButtonText:
                '<i class="fa fa-times"></i> Cancel',
            showClass: {
                popup: 'animated fadeInDown fast',
            },
            hideClass: {
                popup: 'animated fadeOutUp fast',
            },
            confirmButtonColor: '#2d6abd',
            cancelButtonColor: '#abaaaa',
            backdrop: true,
            allowOutsideClick: false,
            buttonsStyling: true
        }).then((result: SweetAlertResult) => {
            return result
        })
    }
    showAlert(data) {
        Swal.fire({
            html: `<h4>${data}</h4>`,
            icon: 'error',
            showClass: {
                popup: 'animated fadeInDown fast',
            },
            hideClass: {
                popup: 'animated fadeOutUp fast',
            },
            backdrop: false,
        });
    }

    movableModel() {
        $(document).ready(() => {
            let modalContent: any = $('.modal-dialog');
            let modalHeader = $('.modal-header');
            modalHeader.addClass('cursor-all-scroll');
            modalContent.draggable({
                handle: '.modal-header'
            });
            // modalContent.draggable({ revert: 'invalid' });
        })
    }

    fromToDate(fromDate: Date, toDate: Date): boolean {
        if ((fromDate !== null && toDate !== null) && fromDate >= toDate) {
            return true;
        }
        else {
            return false;
        }
    }

    public timeSince(date) {
        var currentDate: any = new Date()
        var dateToCalculate: any = new Date(date)
        var seconds = Math.floor((currentDate - dateToCalculate) / 1000);
        seconds += 19800
        var interval = seconds / 31536000;

        if (interval > 1) {
            return Math.floor(interval) + " years";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + " months";
        } 
        interval = seconds / 86400;
        if (Math.floor(interval) == 1) {
            return "Yesterday";
        }
        if (interval > 1) {
            return Math.floor(interval) + " days";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes";
        }
        if(seconds <10){
        return "Just now";
        }

        return Math.floor(seconds) + " seconds";
    }

     prependArray(value, array) {
        var newArray = array.slice();
        newArray.unshift(value);
        return newArray;
      }

    ErrorFocusFirstElementNgModel(form): any {
        for (const key of Object.keys(form.controls)) {
            if (form.controls[key].invalid) {
                return key
            }
        }
    }
    public convertUTCDateToLocalDate(date) {
        let formattedDate = moment.utc(date).format('DD MMM,YYYY hh:mm A');
        return moment.utc(formattedDate).toDate();
    }

    convertDateFromExcelSheet(date) {
        if (isNaN(date)) {
            let momentVariable = moment(date, 'DD/MM/YYYY');
            if (!momentVariable.isValid()) {
                return null
            }
            else {
                let stringvalue = momentVariable.date();
                return new Date(stringvalue)
            }
        }
        else {
            date = new Date(Math.round((date - 25569) * 86400 * 1000));
            return date
        }
    }

    // method to check duplicate entries for particular entity in excel sheet
    ExcelEntityDuplicateCheck(arr): string {
        let duplicates = ''
        let Groupped = _.groupBy(arr, (value) => {
            if (!this.isNullOrUndefined(value))
                return value.toLowerCase();
        });
        _.groupBy(arr, (n) => n);
        let result = _.uniq(_.flatten(_.filter(Groupped, (n) => (n.length > 1))));
        if (result.length > 0) {
            result.forEach(element => {
                if (!this.isNullOrUndefined(element)) {
                    duplicates += element + ", "
                }
            });
        }
        return duplicates
    }

    // method to get array of headers from excel sheet
    get_header_row(sheet) {
        let headers = [];
        if (this.isNullOrUndefined(sheet['!ref'])) {
            return false
        }
        let range = XLSX.utils.decode_range(sheet['!ref']);
        if (this.isNullOrUndefined(range)) {
            return
        }
        let C, R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
            let cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
            let hdr = "UNKNOWN " + C;
            if (cell && cell.t) {
                hdr = XLSX.utils.format_cell(cell);
                headers.push(hdr);
            }
        }
        return headers;
    }

    // this will check null , undefined and empty together (Not for number values only applicable for strings)
    isNullOrUndefinedOrEmpty(str) {
        if (this.isNullOrUndefined(str)) {
            return this.isNullOrUndefined(str)
        }
        else {
            return this.isNullOrUndefined(str) || str.trim() === ""
        }
    }
    showSweetAlert(data, type) {
        if (type == 'error') {
            Swal.fire({
                html: `<h4>${data}</h4>`,
                showClass: {
                    popup: 'animated fadeInDown fast',
                },
                hideClass: {
                    popup: 'animated fadeOutUp fast',
                },
                icon: 'error'
            });
        }
        else if (type == 'warning') {
            Swal.fire({
                html: `<h4>${data}</h4>`,
                showClass: {
                    popup: 'animated fadeInDown fast',
                },
                hideClass: {
                    popup: 'animated fadeOutUp fast',
                },
                icon: 'warning'
            });
        }
        else if (type == 'success') {
            Swal.fire({
                html: `<h4>${data}</h4>`,
                showClass: {
                    popup: 'animated fadeInDown fast',
                },
                hideClass: {
                    popup: 'animated fadeOutUp fast',
                },
                icon: 'success'
            });
        }
        else {
            Swal.fire({
                html: `<h4>${data}</h4>`,
                showClass: {
                    popup: 'animated fadeInDown fast',
                },
                hideClass: {
                    popup: 'animated fadeOutUp fast',
                }
            });
        }
    }

    passingMarksTotalMarksValidation(passingmark, totalMarks) {
        if (passingmark > totalMarks) {
            return true
        }
        else {
            return false
        }
    }

    // method to convert timepicker time to time object
    setTime(event: string) {
        let hour = event.split(/[:\s]+/);
        let exportTime = { hour: hour[0], minute: hour[1] };
        return exportTime
    }

    // method to get difference between two time strings
    getDiff(startTime, endTime) {
        let from = moment(startTime, 'HH:mm A');
        let to = moment(endTime, 'HH:mm A');
        let diff = to.diff(from, 'minutes');
        return diff
    }

    getTimeString(datePickerObject) {
        return datePickerObject.hour + ':' + datePickerObject.minute + ' ' + datePickerObject.meriden;
    }


    // Method to filter landing page components as per user permission
    filterLandingPageComponentsAsPerPermissions(componentArray, userPermissions) {
        componentArray.children.forEach(e => {
            if (e.children) {
                e.children.forEach(element => {
                    let permissions = userPermissions.find(h => h.label === element.permissionName)
                    if (permissions) {
                        if (permissions.access == "n") {
                            e.children = e.children.filter(h => h.name != element.name)
                        }
                    }
                    else {
                        e.children = e.children.filter(h => h.name != element.name)
                    }
                });
                if (e.children.length == 0) {
                    componentArray.children = componentArray.children.filter(h => h.name != e.name)
                }
            }
            else {
                let permissions = userPermissions.find(h => h.label === e.permissionName)
                if (permissions) {
                    if (permissions.access == "n" || (e.access && e.access.length != 0 && !e.access.includes(permissions.access))) {
                        componentArray.children = componentArray.children.filter(h => h.name != e.name)
                    }
                }
                else {
                    componentArray.children = componentArray.children.filter(h => h.name != e.name)
                }
            }
        })
        return componentArray
    }
    formatSizeUnits(bytes) {
        if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
        else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
        else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
        else if (bytes > 1) { bytes = bytes + " bytes"; }
        else if (bytes == 1) { bytes = bytes + " byte"; }
        else { bytes = "0 bytes"; }
        return bytes;
    }

    getEnumList(enums, getOriginalPropName = false) {
        const arrayObjects: Array<IdNameModel> = [];
        for (const [propertyKey, propertyValue] of enums) {
            if (!Number.isNaN(Number(propertyKey))) {
                continue;
            }
            arrayObjects.push({ id: Number(propertyValue), name: propertyKey });
        }
        if (!getOriginalPropName)
            arrayObjects.forEach(e => e.name = e.name.replace(/([A-Z])/g, ' $1').trim())
        return arrayObjects;
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    getEnumObj(enums: any) {
        const arrayObjects: Array<IdNameModel> = [];
        const enumObject: any = [];
        for (const [propertyKey, propertyValue] of enums) {
            if (!Number.isNaN(Number(propertyKey))) {
                continue;
            }
            arrayObjects.push({ id: Number(propertyValue), name: propertyKey });
        }
        arrayObjects.forEach(data => {
            enumObject[data.id] = data.name
        })
        return enumObject;
    }

    onKendoCheckBoxSelection<T, T1, K extends keyof T1>(selectedActionIds: Array<T>, e: SelectionEvent, callbackfn: (obj: T1) => T1[K]) {
        if (!this.isArrayEmpty(e.selectedRows)) {
            let selectedKeyProp = e.selectedRows.map(s => s.dataItem).map(callbackfn);
            _.each(selectedKeyProp, keyValue => {
                if (!selectedActionIds.includes(keyValue)) {
                    selectedActionIds.push(keyValue);
                }
            })
        }

        if (!this.isArrayEmpty(e.deselectedRows)) {
            let deSelectedKeyProp = e.deselectedRows.map(s => s.dataItem).map(callbackfn);
            _.each(deSelectedKeyProp, keyValue => {
                if (selectedActionIds.includes(keyValue)) {
                    selectedActionIds = selectedActionIds.filter(res => res !== keyValue);
                }
            })
        }
        return selectedActionIds;
    }

    onKendoCheckBoxSelectionSyllabusTopics<T, T1>(selectedActionIds: Array<T>, e: SelectionEvent) {
        if (!this.isArrayEmpty(e.selectedRows)) {
            let selectedKeyProp = e.selectedRows.map(s => s.dataItem);
            _.each(selectedKeyProp, keyValue => {
                if (!selectedActionIds.includes(keyValue)) {
                    selectedActionIds.push(keyValue);
                }
            })
        }

        if (!this.isArrayEmpty(e.deselectedRows)) {
            let deSelectedKeyProp = e.deselectedRows.map(s => s.dataItem);
            _.each(deSelectedKeyProp, keyValue => {
                if (selectedActionIds.includes(keyValue)) {
                    selectedActionIds = selectedActionIds.filter(res => res !== keyValue);
                }
            })
        }
        return selectedActionIds;
    }

    totalPage<T>(data: Array<T>, noOfRecordPerPage: number = 10) {
        return Math.ceil(data.length / noOfRecordPerPage);
    }

    onPaginationChange<T>(data: Array<T>, activePage: number, noOfRecordPerPage: number = 10) {
        let firstIndex = (noOfRecordPerPage * activePage) - noOfRecordPerPage;
        let lastIndex = (noOfRecordPerPage * activePage);

        const filteredData: Array<T> = [];

        data.forEach((pre, index) => {
            if (firstIndex <= index && (lastIndex - 1) >= index) {
                filteredData.push(pre);
            }
        });

        if (lastIndex > 0 && firstIndex === 0) {
            firstIndex = 1;
        }

        if (lastIndex > data.length) {
            lastIndex = data.length;
        }

        return { fromRecord: firstIndex, toRecord: lastIndex, filteredData };
    }

    convertHtmlTextToNormalText = (body?: string) => {
        if (!this.isStringEmptyOrWhitespace(body)) {
            return body.replace(/<[^>]*>/g, '');
        }
        return body;
    }

    // get data from enum
    buildArrayFromEnum(type) {
        let enumNames = []
        for (let log in type) {
            if (isNaN(Number(log))) {
                enumNames.push(log);
            }
        }
        return enumNames
    }

    // Mat select select all functions
    optionClickForMatSelect(selectedItem, allSelected) {
        let status = true;
        selectedItem.options.forEach((item: MatOption) => {
            if (!item.selected) {
                status = false;
            }
        });
        allSelected = status;
        return allSelected
    }

    toggleAllForMatSelect(selectedItem, allSelected) {
        if (allSelected) {
            selectedItem.options.forEach((item: MatOption) => {
                item.select()
                if (item.value == 0) {
                    item.deselect();
                }
            });
        } else {
            selectedItem.options.forEach((item: MatOption) => item.deselect());
        }
    }

    // get userList array from enum
    buildArrayFromEnumForUserRole(type) {
        let enumNames: { Id: number; EntityValue: string }[] = [];
        for (let n in type) {
            if (typeof type[n] === 'number') {
                enumNames.push({ Id: type[n] as any, EntityValue: n });
            }
        }
        return enumNames
    }

    // method to convert property in string
    convertToString(value) {
        if (!this.isNullOrUndefined(value) && !this.isStringEmptyOrWhitespace(value)) {
            return value.toString().trim();
        }
        else {
            return null;
        }
    }

    // method to push element in array if element is not null
    pushElementIntoArray(element, arr: any[]) {
        if (!this.isNullOrUndefined(element) && !this.isStringEmptyOrWhitespace(element) && !this.isNullOrUndefined(arr)) {
            arr.push(element)
            return arr
        }
    }
}
